// extracted by mini-css-extract-plugin
export default {"errorContainer":"errorContainer___M1szi"};